(ns manage.adset-decision-tree-page.view.side-panel.poi.converter
  (:require [manage.adset-decision-tree-page.schema-urn :as schema-urn]
            [medley.core :as medley]))

(def default-param
  {:selector-id nil
   :max-radius-km nil})

(defn- param->form-fields
  [{:keys [open-status
           closes-sooner-than closes-later-than
           opens-sooner-than opens-later-than]
    :as param}]
  (let [[time-constraint minutes]
        (case open-status
          "open" (cond
                   (some? closes-sooner-than) ["within" closes-sooner-than]
                   (some? closes-later-than) ["no-sooner-than" closes-later-than]
                   :else [nil nil])
          "closed" (cond
                     (some? opens-sooner-than) ["within" opens-sooner-than]
                     (some? opens-later-than) ["no-sooner-than" opens-later-than]
                     :else [nil nil])
          [nil nil])]
    (-> param
        (dissoc :closes-sooner-than :closes-later-than
                :opens-sooner-than :opens-later-than)
        (assoc :time-constraint time-constraint
               :time-constraint-minutes minutes))))

(defn ->form [value]
  (if (empty? value)
    [{:schema schema-urn/poi
      :alias "poi"
      :param default-param}]
    (mapv #(update % :param param->form-fields) value)))

(defn- form-fields->param
  [{:keys [open-status time-constraint time-constraint-minutes] :as param}]
  (let [base (dissoc param :time-constraint :time-constraint-minutes)]
    (medley/remove-vals nil?
                        (if (and open-status time-constraint time-constraint-minutes)
                          (let [field-key (case [open-status time-constraint]
                                            ["open" "within"] :closes-sooner-than
                                            ["open" "no-sooner-than"] :closes-later-than
                                            ["closed" "within"] :opens-sooner-than
                                            ["closed" "no-sooner-than"] :opens-later-than
                                            nil)]
                            (cond-> base
                              field-key (assoc field-key time-constraint-minutes)))
                          base))))

(defn <-form [[value]]
  [(merge (update value :param form-fields->param)
          {:schema schema-urn/poi
           :alias "poi"})])

(def schema
  [:sequential
   [:map {:error/message ""}
    [:param [:map {:error/message ""}
             [:selector-id [:int {:error/message "Selector is required"}]]
             [:max-radius-km [:int {:min 1 :error/message "Max radius is required"}]]]]]])
